<template>
  <div v-if="isShow"
       class="filter-tags">
    <BasePreloader v-if="pending"/>
    <div v-if="windowSizeMixin.width > WINDOW_SIZE_SM"
         :style="{opacity: pending ? '0.5' : null}"
         class="filter-tags__container">
      <button v-if="searchValue"
              key="searchValue"
              @click="onDeleteOneQuery(otherKeys.SEARCH)"
              class="filter-tags__btn tag-btn">
        <span class="tag-btn__text">
          {{ $tFilter('Search') }}: {{ searchValue }}
        </span>
        <BaseSvg class="tag-btn__ico-close"
                 name="ico-close"/>
      </button>
      <button v-if="country"
              key="country"
              @click.prevent="onStaticParamDelete(staticFiltersKeys.COUNTRY)"
              class="filter-tags__btn tag-btn">
        <span class="tag-btn__text">
          {{ country.name }}
        </span>
        <BaseSvg class="tag-btn__ico-close"
                 name="ico-close"/>
      </button>
      <!--  && !!country -->
      <button v-if="city"
              key="city"
              @click.prevent="onStaticParamDelete(staticFiltersKeys.CITY)"
              class="filter-tags__btn tag-btn">
        <span class="tag-btn__text">
          {{ city.name }}
        </span>
        <BaseSvg class="tag-btn__ico-close"
                 name="ico-close"/>
      </button>

      <button v-for="category in categories"
              :key="'categories' + category.slug"
              @click.prevent="onDeleteCategory(category)"
              class="filter-tags__btn tag-btn">
        <span class="tag-btn__text">
          {{ category.title }}
        </span>
        <BaseSvg class="tag-btn__ico-close"
                 name="ico-close"/>
      </button>

      <button v-for="filter in dynamicFiltersItemsFormat"
              :key="'dynamicFilters' + filter.slug + filter.value.slug"
              @click.prevent="onDeleteDynamicParam(filter.value.slug)"
              class="filter-tags__btn tag-btn">
        <span class="tag-btn__text">
          {{ filter.title }}: {{ filter.value.title }}
        </span>
        <BaseSvg class="tag-btn__ico-close"
                 name="ico-close"/>
      </button>

      <button @click.prevent="onDeleteAllClick"
              class="filter-tags__btn tag-btn _orange">
        <span class="tag-btn__text">{{ $tFilter('Clear all') }}</span>
        <BaseSvg class="tag-btn__ico-close"
                 name="ico-close"/>
      </button>
    </div>
    <div v-else class="filter-tags__container">
      <button @click.prevent="$vModal.open('main-filter-mobile')"
              class="filter-tags__btn tag-btn _filter">
        <BaseSvg class="tag-btn__ico-filter"
                 name="ico-filter"/>
        <span class="tag-btn__text">{{ $tFilter('Filter') }}</span>
        <span class="tag-btn__amount">{{ filtersCount }}</span>
      </button>
      <button v-if="filtersCount > 0"
              @click.prevent="onDeleteAllClick"
              class="filter-tags__btn tag-btn _orange _clear">
        <span class="tag-btn__text">{{ $tFilter('Clear all') }}</span>
        <BaseSvg class="tag-btn__ico-close"
                 name="ico-close"/>
      </button>
    </div>
  </div>
</template>

<script>
  import filterMixin from '../mixins/filterMixin'
  import windowSizeMixin from '../mixins/windowSizeMixin'
  import {WINDOW_SIZE_SM} from '@/constants/windowSizes'
  import {mapGetters, mapState} from "vuex"
  import toggleDynamicFilterKeyInRoute from "@/store/vacancies/common/toggleDynamicFilterKeyInRoute"

  export default {
    name: "FilterTags",
    mixins: [windowSizeMixin, filterMixin],
    data() {
      return {
        WINDOW_SIZE_SM,
      }
    },
    computed: {
      ...mapState('vacancies', [
        'pending',
        'otherKeys',
        'staticFiltersKeys',
        'country',
        'city',
        'directions',
      ]),
      ...mapGetters('vacancies', [
        'dynamicFiltersItems',
      ]),
      searchValue() {
        return this.$route.query[this.otherKeys.SEARCH]
      },
      categories() {
        return this.directions
      },
      dynamicFiltersItemsFormat() {
        return this.dynamicFiltersItems.map(item => {
          return {
            title: item.group.title,
            slug: item.group.slug,
            value: {
              title: item.title,
              slug: item.slug,
            }
          }
        })
      },
      isShow() {
        return (
            this.searchValue ||
            this.country ||
            this.city ||
            this.categories && this.categories.length ||
            this.dynamicFiltersItemsFormat && this.dynamicFiltersItemsFormat.length ||
            this.windowSizeMixin.width < (WINDOW_SIZE_SM + 1)
        )
      },
      filtersCount() {
        let count = 0
        if (this.searchValue) ++count
        if (this.country) ++count
        if (this.city) ++count
        if (this.categories) count += this.categories.length
        if (this.dynamicFiltersItemsFormat) count += this.dynamicFiltersItemsFormat.length

        return count
      },
    },
    methods: {
      onDeleteDynamicParam(slug) {
        toggleDynamicFilterKeyInRoute([false, slug])
      },
      onDeleteOneQuery(queryName) {
        const query = {...this.$route.query}
        delete query[queryName]

        this.$router.push({
          query
        })
      },
      onDeleteCategories(queryName) {
        const query = {...this.$route.query}
        delete query[queryName]

        this.$router.push({
          query
        })
      },
      onDeleteCategory(category) {
        let categories = this.$route.query[this.otherKeys.CATEGORIES]

        if(categories) {
          categories = categories.split('|')
          categories = categories.filter(s => s !== category.slug)
          categories = categories.join('|')
        }

        this.pushToRouterMixin({
          query: {
            categories: categories || null,
          }
        })
      },
      async onStaticParamDelete(slug) {
        await this.setStaticFilter(slug, null)
        if (slug == 'country' && this.city) {
          await this.setStaticFilter('city', null)
        }
      },

      onDeleteAllClick() {
        this.$router.push({
          name: 'vacancies',
          query: this.$route.query[this.otherKeys.SORT] ? {
            [this.otherKeys.SORT]: this.$route.query[this.otherKeys.SORT],
          } : null
        })

        this.$store.dispatch('sendAlert', {type: 'click', title: 'Vacancies - clear all filters.'})
      },
      onDeleteOnePlainClick(queryName) {
        const query = {...this.$route.query}
        delete query[queryName]
        this.$router.push({
          query,
        })
      }
    },
    watch:{
      country() {
        let str;
        if(this.city && this.country) {
          str = `Country: ${this.country.name}, city: ${this.city.name}.`
        } else if(this.country) {
          str = `Country: ${this.country.name}.`
        }
        if(str !== undefined) {
          this.$store.dispatch('sendAlert', {
            type: 'filter',
            title: str
          })
        }
      },
      categories() {
        if(this.categories !== null) {
          let str = `Categories: ${this.categories.map((i)=>{return i.title})}`
          if(this.categories.length && str !== undefined) {
            this.$store.dispatch('sendAlert', {
              type: 'filter',
              title: str
            })
          }
        }
      }
    }
  }
</script>

<style>

</style>
